import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  open: false,
  message: '',
  severity: 'info',
  variant: null,
  templateKey: null,
};

const snackbarSlice = createSlice({
  name: 'snackbar',
  initialState,
  reducers: {
    showSnackbar: (state, action) => {
      state.open = true;
      state.message = action.payload.message ?? '';
      state.severity = action.payload.severity;
      state.variant = action.payload.variant ?? null;
      state.templateKey = action.payload.templateKey ?? null;
    },
    hideSnackbar: (state) => {
      state.open = false;
      state.message = '';
      state.severity = 'info';
      state.variant = null;
      state.templateKey = null;
    },
  },
});

export const { showSnackbar, hideSnackbar } = snackbarSlice.actions;
export default snackbarSlice.reducer;
